// import { useNavigate } from "react-router-dom";
// import { Button } from "tvs-unified-lib";

import { Container, ErrorIcon, Message, Title } from "./styles";

export default function AccessDenied() {
  // const navigate = useNavigate();

  return (
    <Container>
      <ErrorIcon />
      <Title>Access Denied</Title>
      <Message>
        We're sorry, but you don't have permission to access this page. Please
        contact your administrator if you believe this is a mistake.
      </Message>
      {/* TODO: Add button to navigate to login page */}
      {/* <ButtonContainer>
        <Button
          onClick={() => navigate("/login")}
          theme="purple"
          variant="block"
          label="Return to Login"
        />
      </ButtonContainer> */}
    </Container>
  );
}
